import rolesJson from "@/data/roles.json";

export interface UseCase {
  name: string;
  steps: string[];
}

export interface Faq {
  q: string;
  a: string;
}

export interface Role {
  slug: string;
  title: string;
  tagline: string;
  hero: string;
  pains: string[];
  benefits: string[];
  useCases: UseCase[];
  faqs: Faq[];
}

const roles = rolesJson as Role[];

export function allRoles(): Role[] {
  return roles;
}

export function roleBySlug(slug: string): Role | undefined {
  return roles.find((r) => r.slug === slug);
}

export function relatedRoles(slug: string, count = 4): Role[] {
  const idx = roles.findIndex((r) => r.slug === slug);
  if (idx === -1) return roles.slice(0, count);
  // Wrap-around slice for "next" feeling.
  const out: Role[] = [];
  for (let i = 1; i <= count; i++) {
    out.push(roles[(idx + i) % roles.length]);
  }
  return out;
}

/**
 * Tag buckets for the /for hub filter. Roles can appear in multiple categories;
 * unknown roles fall through to "Other".
 */
export const CATEGORIES: Record<string, string[]> = {
  "Sales & Growth": [
    "sales-professionals",
    "realtors",
    "insurance-agents",
    "financial-advisors",
    "startup-founders",
    "entrepreneurs",
    "marketers",
    "content-creators",
    "recruiters",
  ],
  "Operations & Support": [
    "operations-managers",
    "customer-support",
    "project-managers",
    "hr-professionals",
    "office-managers",
    "administrative-assistants",
    "executive-assistants",
    "virtual-assistants",
  ],
  "Creative & Content": [
    "writers",
    "content-creators",
    "designers",
    "marketers",
    "freelancers",
    "coaches-consultants",
  ],
  "Leadership": [
    "executives",
    "managers",
    "startup-founders",
    "small-business-owners",
    "nonprofit-leaders",
  ],
  "Professional Services": [
    "lawyers",
    "accountants",
    "financial-advisors",
    "consultants",
    "coaches-consultants",
    "therapists",
    "doctors",
  ],
  "Education & Research": [
    "teachers",
    "professors",
    "students",
    "researchers",
    "academics",
  ],
};

export function categoriesForRole(slug: string): string[] {
  return Object.entries(CATEGORIES)
    .filter(([, slugs]) => slugs.includes(slug))
    .map(([cat]) => cat);
}
